import type { FC } from "react";

import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import { webSourceTextSlimFilter } from "app/filters/ngFilters";
import type { ISegmentsWebSourceSectionProps } from "app/pages/segments/redesigned-wizard/segment-wizard/types";
import { LeftFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { webSourceIcon } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

const { carbon } = colorsPalettes;

const WebSourceWrapper = styled(LeftFlexRow)`
    height: 16px;
    padding: 6px 24px;
    background-color: ${carbon[200]}30;
    color: ${carbon[400]};
`;
export const SegmentsWebSourceSection: FC<ISegmentsWebSourceSectionProps> = ({ webSource }) => {
    return (
        <WebSourceWrapper>
            <SWReactIcons
                iconName={webSourceIcon(webSource)}
                iconColor={carbon[250]}
            />
            {webSourceTextSlimFilter()(webSource)}
        </WebSourceWrapper>
    );
};
